import { render, staticRenderFns } from "./FrameSelect.vue?vue&type=template&id=15ac4890&"
import script from "./FrameSelect.vue?vue&type=script&lang=js&"
export * from "./FrameSelect.vue?vue&type=script&lang=js&"
import style0 from "./FrameSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports